import React from "react";
import styles from "./machines-list-header-expand-collapse-all.module.scss";
import { useI18N } from "@src/language/language-context";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { transformedGatewaysWithMachinesListEntryTypes } from "@common/types/machines-list-types";

const cssClassName = "machines-list-header-expand-collapse-all";

interface MachinesListHeaderExpandCollapseAllPropsTypes {
  companyEntries: transformedGatewaysWithMachinesListEntryTypes[];
  onExpandAll: () => void;
  onCloseAll: () => void;
}

export const MachinesListHeaderExpandCollapseAll = ({
  companyEntries,
  onExpandAll,
  onCloseAll,
}: MachinesListHeaderExpandCollapseAllPropsTypes) => {
  const i18n = useI18N();

  const areAllCompaniesCollapsed =
    companyEntries.length > 0 &&
    companyEntries.every((item) => !item?.sources_visible);
  const hasAnyExpandedCompany = companyEntries.some(
    (item) => item?.sources_visible === true,
  );

  const texts = {
    addFilter: i18n("modules.machinesListHeaderExpandCollapseAll.addFilter"),
    companies: i18n("modules.machinesListHeaderExpandCollapseAll.companies"),
    expandAll: i18n("modules.machinesListHeaderExpandCollapseAll.expandAll"),
    closeAll: i18n("modules.machinesListHeaderExpandCollapseAll.closeAll"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__expand-section`]}>
        <span className={styles[`${cssClassName}__companies-text`]}>
          {texts.companies}
        </span>
        {areAllCompaniesCollapsed && (
          <TextButton
            clickHandler={onExpandAll}
            text={texts.expandAll}
            variant="blue"
          />
        )}
        {hasAnyExpandedCompany && (
          <TextButton
            clickHandler={onCloseAll}
            text={texts.closeAll}
            variant="blue"
          />
        )}
      </div>
    </div>
  );
};
